module.exports = __webpack_public_path__ + "static/media/5.3bddc721.PNG";